;
define("merchandising_zone_cell_template.tpl", function(){});

